/** Shared properties for Segment/analytics events on the booking form flow. */
export const BOOKING_FORM_ANALYTICS_PROPS = {
	website_variant: 'B',
};
